<template>
  <div class="rename-modal">
    <transition name="fade">
      <div
        v-if="visible"
        class="cover"
        @click="cancel"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="message-container"
      >
        <div class="message-header">简历名称</div>
        <div class="message-content">
          <div class="message-input-main">
            <EditorInput
              v-model="name"
              placeholder="请输入简历名称"
              style="width: 100%"
              styleType="1"
            />
          </div>
          <div
            class="err-msg"
            v-if="errorShow"
            style="margin-bottom: -4px"
          >
            <i class="iconfont iconcuowu"></i>
            <span>{{ errorMsg }}</span>
          </div>
        </div>
        <div class="message-labels-content">
          <p class="sub-title">选择模块内容，生成专业简历名称</p>
          <div class="select-list flex">
            <div
              @click="selectLabel(item)"
              class="select-item"
              :class="{ 'is-active': item.checked }"
              v-for="(item, index) in nameSelect"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="message-btn">
          <button
            class="cancel"
            @click="cancel"
          >
            取消
          </button>
          <button
            class="action"
            @click="confirm"
          >
            保存
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import EditorInput from '../EditorInput/EditorInput.vue';
import api from '@/api';
export default {
  name: 'EditorRenameModal',
  components: {
    EditorInput,
  },
  data() {
    return {
      cvNameAlert: false,
      errorMsg: '名称不能包含下列任何字符：+/\<>*?:|""、', // 修改简历名称时校验提示文案
      errorShow: false,
      nameSelect: [],
      cvInfo: {},
      name: '',
      token: '',
      isSava: false,
      visible: false,
    };
  },
  props: {
    cvToken: {
      type: String,
      default: '',
    },
    cvName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    ...mapState('cv', ['cvs']),
  },
  methods: {
    ...mapMutations('editor', ['setCvDetail']),
    ...mapMutations('cv', ['setCvs']),
    show() {
      this.name = this.cvName;
      this.token = this.cvToken;
      this.getNamePart();
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.$emit('editCvName', '', this.name);
    },
    cancel() {
      this.visible = false;
      this.$emit('editCvName', '', this.cvName);
    },
    confirm() {
      this.saveSetting();
    },
    async getNamePart() {
      let res = await api.cvsEditor.getCvNamePart(this.token);
      if (res.code === 1000) {
        this.nameSelect = res.data.options;
      }
    },
    // 选择简历名称的label
    selectLabel(item) {
      item.checked = !item.checked;
      if (item.checked) {
        this.name += `_${item.display_name}`;
      } else {
        let name = new RegExp(`_${item.display_name}|${item.display_name}`, 'gi');
        this.name = this.name.replace(name, '');
      }
      if (this.name.substr(0, 1) === '_') this.name = this.name.slice(1);
      this.$forceUpdate();
    },
    // 保存设置名称
    async saveSetting(save) {
      if (this.isSava) return;
      this.isSava = true;
      let reg = /[+/\\<>*?:|"、]/im;
      if (reg.test(this.name)) {
        this.errorShow = true;
        return;
      }
      this._saveCvName();
    },
    // 更新简历名称的接口
    async _saveCvName() {
      let name_parts = this.nameSelect.filter((v) => v.checked).map((v) => v.value);
      let res = await api.cvsEditor.updatedCvInfo(this.token, {
        operation_type: 'update_basic_info',
        basic_info: {
          cv_name: this.name,
          name_parts,
        },
      });
      if (res.code === 1000) {
        let list = JSON.parse(JSON.stringify(this.cvs));
        list.forEach((item) => {
          if (item.token === this.token) {
            item.cv_name = this.name;
          }
        });
        this.setCvs(list);
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
        cvDetail.basic_info.cv_name = this.name;
        //标题名称同步到vuex中
        this.setCvDetail(cvDetail);
        this.close();
        this.errorShow = false;
        this.$message.success('设置成功');
      }
      this.isSava = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/modal.scss';
.select-list .select-item {
  border-radius: 6px;
}
</style>
